import { render, staticRenderFns } from "./ConferenceRoomRequests.vue?vue&type=template&id=6732c263&scoped=true"
import script from "./ConferenceRoomRequests.vue?vue&type=script&lang=js"
export * from "./ConferenceRoomRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6732c263",
  null
  
)

export default component.exports